export default __webpack_public_path__ + "static/media/TechCrunch.92e9c8d1.svg";